<div class="modal-header" id="equipment-configuration-modal-title">
    <h3 class="modal-title" id="modal-title" translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body" *ngrxLet="softwareLicences$; let softwareLicences">
    <form [formGroup]="equipmentConfigurationForm">
        <fieldset>
            <div class="row mb-2">
                <div class="col-12">
                    <tabset type="pills" paceCoreTabsRole>
                        <tab [heading]="allEquipmentsLabel" (selectTab)="switchTabs(0)"></tab>
                        <tab
                            [heading]="withServiceKeyLabel"
                            (selectTab)="switchTabs(1)"
                            [active]="serviceKeyTabAsDefault"
                        ></tab>
                        <tab
                            *ngIf="enableSoftwareLicences"
                            [heading]="softwareLicencesLabel"
                            (selectTab)="displaySoftwareLicences()"
                        ></tab>
                    </tabset>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <ng-container
                        [ngTemplateOutlet]="sortableList"
                        [ngTemplateOutletContext]="{
                            tableModel: !softwareLicencesDisplayed ? model.tableModel : softwareLicences,
                        }"
                    >
                    </ng-container>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <button
        class="btn btn-primary"
        type="button"
        *ngIf="softwareLicencesDisplayed"
        (click)="updateSoftwareLicences()"
        translate="NOTIFICATION_DETAIL_EQUIPMENTS_CONFIGURATION_UPDATE_SOFTWARE_LICENCES"
    ></button>
</div>

<ng-template #sortableList let-tableModel="tableModel">
    <div class="d-flex container-fluid table-header fw-bold py-2">
        <div class="col-1"></div>
        <div *ngFor="let column of tableModel.options.columns" class="col">
            <div (click)="doSort(column.field)">
                <span> {{ column.title }} </span>
                <fa-icon
                    *ngIf="reverseSort && orderByField === column.field && tableModel.rows.length > 0"
                    [icon]="faSortDown"
                ></fa-icon>

                <fa-icon
                    *ngIf="!reverseSort && orderByField === column.field && tableModel.rows.length > 0"
                    [icon]="faSortUp"
                ></fa-icon>
            </div>
        </div>
    </div>
    <div class="container-fluid" *ngrxLet="softwareLicences$; let softwareLicences">
        <div class="table-row" *ngFor="let row of tableModel.rows | orderBy: orderByField : reverseSort">
            <pace-equipment-configuration-detail
                [tableModel]="tableModel"
                [equipConfigModel]="model"
                [rowData]="row"
                [softwareLicencesDisplayed]="softwareLicencesDisplayed"
                [technicalIdOrFunctionalLocationLabel]="technicalIdOrFunctionalLocationLabel"
                [softwareLicences]="softwareLicences"
                [displayMaparField]="displayMaparField"
                [displayContractField]="displayContractField"
            ></pace-equipment-configuration-detail>
        </div>
    </div>
</ng-template>
